export default __webpack_public_path__ + "static/icon-woman-f46a9d5b7a42d55486f3d275282f0f10.png";